import React from "react";

import { Wrapper, Partner, PartnerCover, WrapCover, Cover, PartnerDetails, WrapperLogo, Logo, Title, Button } from "./styles";

import PartnerBannerPlaceholder from "../../../../assets/images/placeholders/partner-banner-760x346.png";

export const ShowDesciptionButton = ({ icon, onClick }) => <Button type="button" onClick={onClick}>Saiba mais {icon && icon} </Button>


export const PartnerHead = ({ title, cover, partnerLogo, children }) => {

    return (

        <Wrapper>
            <Partner>
                <PartnerCover>
                    <WrapCover>
                        <Cover
                            onError={(e) => e.target.src = PartnerBannerPlaceholder}
                            src={cover}
                            alt={title ? title : "Alt image"}
                        />
                    </WrapCover>
                    <PartnerDetails>
                        <WrapperLogo>
                            <Logo
                                onError={(e) => e.target.src = PartnerBannerPlaceholder}
                                src={partnerLogo}
                                imageAlt={title ? title : "Alt image"}
                            />
                        </WrapperLogo>
                        <Title>{title}</Title>
                        {children}
                    </PartnerDetails>
                </PartnerCover>

            </Partner>


        </Wrapper>
    )
}